// @ts-strict-ignore
import { format } from 'date-fns';

import { DateFormat } from 'constants/date';
import { Filter } from 'constants/filters/filter';
import type {
  ITicketRatingsData,
  ITicketSatisfactionRankingPeriodData,
  ITicketSatisfactionRatingPeriodData,
} from 'interfaces/reports';
import type { ReportData } from 'interfaces/reports/api-v3';
import { AppStateProvider } from 'services/app-state-provider';

import { getFilters } from '../selectors';

import { rankingDeserializer, RankingType } from './ranking-deserializer';
import { ratingDeserializer } from './rating-deserializer';

interface TicketRatingsPayload {
  data: {
    ticketsRankingResponse: ReportData<ITicketSatisfactionRankingPeriodData>;
    ticketsRatingResponse: ReportData<ITicketSatisfactionRatingPeriodData>;
  };
}

export function ticketRatingsDeserializer({ data }: TicketRatingsPayload): ITicketRatingsData {
  const filters = AppStateProvider.selectFromStore(getFilters);
  const dateFrom = format(filters[Filter.DateRange].from, DateFormat.ISO8601Date);
  const dateTo = format(filters[Filter.DateRange].to, DateFormat.ISO8601Date);
  const tag = filters[Filter.Tag];
  const ranking = rankingDeserializer(data.ticketsRankingResponse || [], {
    rankingType: RankingType.Tickets,
    dateFrom,
    dateTo,
    tag,
  });

  const ticketRating = ratingDeserializer(data.ticketsRatingResponse);

  const ratingData: ITicketRatingsData = {
    ranking,
    ticketRating,
  };

  return ratingData;
}
